import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=144c4bd0&scoped=true&"
import script from "./TagModal.vue?vue&type=script&lang=ts&"
export * from "./TagModal.vue?vue&type=script&lang=ts&"
import style0 from "./TagModal.vue?vue&type=style&index=0&id=144c4bd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c4bd0",
  null
  
)

export default component.exports